import type { SubmissionAction } from '@/classes/SubmissionStatuses/types'
import FixPaymentModalContent, {
	type FixPaymentProps,
} from '@/components/home/SubmissionStatuses/ResubmissionModals/FixPaymentModalContent.vue'

export default class FixPaymentAction implements SubmissionAction {
	buttonText = 'Fix'
	component = FixPaymentModalContent
	componentProps: Omit<FixPaymentProps, 'planId'>

	constructor(purchaseAmount?: string) {
		this.componentProps = {
			purchaseAmount: purchaseAmount ? Number(purchaseAmount) : undefined,
		}
	}
}
